import React from 'react';
import { useFieldHelper } from 'framework/ui/field';
import { v4 as uuidv4 } from 'uuid';
import Stack from '@mui/material/Stack';
import { Box, Typography } from '@mui/material';

const SkillsBadges = () => {
  const { getValue } = useFieldHelper({ source: 'skills' });
  const displayValueRaw = getValue();
  const displayValue = Array.isArray(displayValueRaw) ? displayValueRaw : [];
  const uniqueSet = new Set(displayValue);
  const uniqueArray = Array.from(uniqueSet);
  if (uniqueArray.length === 0) {
    return '';
  }
  return (
    <Stack>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px 5px' }}>
        {uniqueArray.map((skill: string) => {
          const badgeId = uuidv4();
          return (
            <Typography
              component="span"
              key={badgeId}
              sx={{
                backgroundColor: 'primary.main',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'common.white',
                borderRadius: '3px',
                lineHeight: '22.4px',
                border: 0,
                fontSize: '14px',
                padding: '1px 8px',
              }}
            >
              {skill}
            </Typography>
          );
        })}
      </Box>
    </Stack>
  );
};

export default SkillsBadges;
